import { Controller, FieldValues, useFormContext } from 'react-hook-form';

import { TFormDropzoneProps } from '@/shared/components/ui/form/components/file-dropzone/file-dropzone.types';

import { DropzoneInput } from './components/dropzone-input/dropzone-input';

export const FormDropzone = <TFieldValues extends FieldValues>({
  name,
  disabled,
  ...props
}: TFormDropzoneProps<TFieldValues>) => {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <DropzoneInput
            disabled={disabled}
            value={value}
            onChange={onChange}
            error={!!error}
            errorMessage={error?.message}
            {...props}
          />
        );
      }}
    />
  );
};
